// src/routes.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/landing/LandingPage";
import LearnerDetailsPage from "./pages/learner/learnerDetailsPage";
import AssessmentPage from "./pages/learner/assessmentPage";
import LoginRegisterPage from "./pages/auth/LoginRegisterPage";
import Dashboard from "./pages/dashboard/Dashboard";
import ProjectListPage from "./pages/projects/ProjectListPage";
import useAuth from "./hooks/useAuth";
// import Material from './pages/Materials/Material';
import MaterialList from "./pages/Materials/MaterialList";
import MaterialUpload from "./pages/Materials/MaterialUpload";
import CreateAssessmentPage1 from "./pages/questions/CreateAssessmentPage1";
import CreateAssessmentPage2 from "./pages/questions/CreateAssessmentPage2";
import AssessmentDesignerPage from "./pages/questions/AssessmentDesignerPage";
import ViewQuestionnairePage from "./pages/questions/ViewQuestionnairePage";
import AssessmentResultsPage from "./pages/learner/AssessmentResultsPage";
import PastAssessmentDetails from "./pages/learner/pastAssestmentDetails";
import AdminLogin from "./pages/admin/adminLogin";
import DashboardAdmin from "./components/admin/Dashboard";
import SelectNextStepsPage from "./pages/projects/SelectNextStepsPage";
import SelfCreateAssessmentPage1 from "./pages/questions/SelfCreateAssessmentPage1";
import SelfCreateAssessmentPage2 from "./pages/questions/SelfCreateAssessmentPage2";
import SelfCreateAssessmentPage3 from "./pages/questions/SelfCreateAssessmentPage3";
import Consumption from "./pages/dashboard/Consumption";
import Layout from "./Layout";
import ProfilePage from "./pages/profile/ProfilePage";
import PurchasesTab from "./pages/profile/purchasesTab";
import BuyPage from "./pages/Buy/buyPage";
import CompanyTermsAndPolicy from "./components/common/PrivacyPolicy/CompanyTermsAndPolicy";
import PriceDetails from "./pages/NavDetails/PriceDetails";
import ProductDetails from "./pages/NavDetails/ProductDetails";
import TalkToUs from "./pages/NavDetails/TalkToUs";
import ExploreAssessments from "./pages/landing/ExploreAssessments";
const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const token = localStorage.getItem("token");
  return user || token ? children : <Navigate to="/login_register" />;
};

const AdminProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("adminToken"); // Admin-specific token
  return token ? (
    children
  ) : (
    <Navigate to="/admin/secret-portal-entry/admin-login-x29f4Y$-fortress" />
  );
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login_register" element={<LoginRegisterPage />} />
        <Route path="/learner-details" element={<LearnerDetailsPage />} />
        <Route path="/assessment" element={<AssessmentPage />} />
        <Route path="/termsAndPolicy" element={<CompanyTermsAndPolicy />} />
        <Route path="/products" element={<ProductDetails />} />
        <Route path="/pricing" element={<PriceDetails />} />
        <Route path="/talktous" element={<TalkToUs />} />
        <Route path="/explore-assessments" element={<ExploreAssessments />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/consumption_statistics"
          element={
            <ProtectedRoute>
              <Consumption />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
        {/* New route for Project List Page */}
        <Route
          path="/projects"
          element={
            <ProtectedRoute>
              <ProjectListPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/select-next-steps"
          element={
            <ProtectedRoute>
              <SelectNextStepsPage />
            </ProtectedRoute>
          }
        />

        {/* <Route path="projects/materials/:projectId" element={
        <ProtectedRoute>
          <Material/>
        </ProtectedRoute>
      }/> */}

        <Route
          path="/material_list/:projectId"
          element={
            <ProtectedRoute>
              <MaterialList />
            </ProtectedRoute>
          }
        />

        <Route
          path="/material_upload"
          element={
            <ProtectedRoute>
              <MaterialUpload />
            </ProtectedRoute>
          }
        />
        <Route
          path="/buy_items"
          element={
            <ProtectedRoute>
              <BuyPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/your_order_history"
          element={
            <ProtectedRoute>
              <PurchasesTab />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-assessment/step1/:projectId"
          element={
            <ProtectedRoute>
              <CreateAssessmentPage1 />
            </ProtectedRoute>
          }
        />

        <Route
          path="/create-assessment/step2/:projectId"
          element={
            <ProtectedRoute>
              <CreateAssessmentPage2 />
            </ProtectedRoute>
          }
        />

        <Route
          path="/create-assessment/step3/:projectId"
          element={
            <ProtectedRoute>
              <AssessmentDesignerPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/self-create-assessment/step1/:projectId"
          element={
            <ProtectedRoute>
              <SelfCreateAssessmentPage1 />
            </ProtectedRoute>
          }
        />

        <Route
          path="/self-create-assessment/step2/:projectId"
          element={
            <ProtectedRoute>
              <SelfCreateAssessmentPage2 />
            </ProtectedRoute>
          }
        />

        <Route
          path="/self-create-assessment/step3/:projectId"
          element={
            <ProtectedRoute>
              <SelfCreateAssessmentPage3 />
            </ProtectedRoute>
          }
        />

        <Route
          path="/view-questionnaire/:projectId"
          element={
            <ProtectedRoute>
              <ViewQuestionnairePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/assessment-results/:projectId"
          element={
            <ProtectedRoute>
              <AssessmentResultsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/pastAssessment/:id"
          element={
            <ProtectedRoute>
              <PastAssessmentDetails />
            </ProtectedRoute>
          }
        />
        {/* Admin Login Route */}
        <Route
          path="admin/secret-portal-entry/admin-login-x29f4Y$-fortress"
          element={<AdminLogin />}
        />
        {/* Admin Dashboard Route */}
        <Route
          path="admin/secret-portal-entry/admin-dashboard"
          element={
            <AdminProtectedRoute>
              <DashboardAdmin />
            </AdminProtectedRoute>
          }
        />
        <Route path="*" element={<h1>404 - No Page Found</h1>} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;